"use client";

import {
  useKeyboardActive,
  useKeyboardEnabled,
} from "@/contexts/studio-context";
import { Group, Line, SectionHeader, Switch } from "./atoms";
import { SET } from "./palette";

export function KeyboardSection() {
  const [enabled, setEnabled] = useKeyboardEnabled();
  const active = useKeyboardActive();

  return (
    <section style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <SectionHeader
        kicker="Clavier d'ordinateur"
        trailing={
          <Switch
            checked={enabled}
            onChange={setEnabled}
            label="Activer le clavier d'ordinateur"
          />
        }
      />

      <Group>
        <Line
          withDivider={false}
          label="Statut"
          hint={
            enabled
              ? active
                ? "Les touches du clavier jouent du piano sur l'écran studio."
                : "Activé. Le clavier sera capturé dès que tu ouvriras le studio."
              : "Désactivé. Les touches ne déclencheront aucune note."
          }
          control={
            <span
              style={{
                fontSize: 11,
                color: active ? SET.violetLight : SET.textMute,
                fontVariantNumeric: "tabular-nums",
              }}
            >
              {active ? "actif" : enabled ? "en attente" : "inactif"}
            </span>
          }
        />
      </Group>
    </section>
  );
}
